import React from "react";
import { founder } from "../data/mock";
import { Linkedin, ExternalLink } from "lucide-react";
import { Reveal, ChapterTag } from "../lib/motion";

export const FounderSection = () => {
  return (
    <section id="about-shakirah" data-testid="founder-section" className="py-24 sm:py-32 bg-[#032e2d] relative grain overflow-hidden">
      <div className="absolute bottom-0 left-0 w-[420px] h-[420px] rounded-full bg-[#A86532]/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <Reveal>
          <ChapterTag num="09" label="About Shakirah" dark />
        </Reveal>

        <div className="mt-10 grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20 items-start">
          {/* Portrait */}
          <Reveal delay={0.1} className="lg:sticky lg:top-28">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-brand-800 to-[#0a4443] aspect-[4/5] flex items-center justify-center border border-teal-100/10" data-testid="founder-portrait">
              {founder.photo ? (
                <img src={founder.photo} alt={founder.name} className="w-full h-full object-cover" />
              ) : (
                <div className="text-center px-8">
                  <span className="font-display font-normal  text-8xl text-teal-100/80">SA</span>
                  <p className="mt-4 text-xs uppercase tracking-[0.22em] text-teal-200/50">Shakirah Akinwale</p>
                </div>
              )}
              <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-[#032e2d]/85 backdrop-blur-md px-5 py-4 border border-teal-100/10">
                <p className="text-white font-semibold text-sm">{founder.name}</p>
                <p className="text-teal-200/70 text-xs mt-0.5">{founder.role}</p>
              </div>
            </div>
          </Reveal>

          {/* Copy */}
          <div>
            <Reveal>
              <h2 className="font-display font-semibold text-white tracking-tight text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.12]">
                Business thinking. <em className=" text-brand-300">Technology understanding.</em> Hands-on delivery.
              </h2>
            </Reveal>
            <div className="mt-8 space-y-5">
              {founder.paragraphs.map((p, i) => (
                <Reveal key={i} delay={0.06 * i}>
                  <p className="text-teal-100/75 leading-relaxed text-base">{p}</p>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.2}>
              <p className="mt-8 font-display  text-teal-50/90 text-base md:text-lg leading-relaxed border-l-2 border-[#A86532] pl-5">
                {founder.transparency}
              </p>
            </Reveal>

            <Reveal delay={0.25}>
              <div className="mt-8 flex flex-wrap gap-2">
                {founder.tags.map((tag) => (
                  <span key={tag} className="px-3.5 py-1.5 text-xs font-medium text-teal-100/80 rounded-full border border-teal-100/20 hover:border-brand-400/60 hover:text-white transition-colors duration-200">
                    {tag}
                  </span>
                ))}
              </div>
              <a
                href={founder.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="founder-linkedin-link"
                className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-brand-300 hover:text-white transition-colors duration-200 link-underline"
              >
                <Linkedin className="w-4 h-4" />
                Connect with Shakirah on LinkedIn
                <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
